import React, {FC} from 'react';
import {Drawer} from 'antd';

type Props = {
    visible: boolean;
    onClose: () => void;
    width?: number | string;
    mask?: boolean;
    className?: string;
};

const SideView: FC<Props> = ({ children, visible, onClose, width, mask, className }) => {
    return (
        <Drawer
            className={`side-view ${className}`}
            width={width ?? 650}
            placement="right"
            closable={true}
            onClose={onClose}
            visible={visible}
            mask={mask}
        >
            {children}
        </Drawer>
    );
};

export default SideView;
